import { useState } from "react";
import { motion } from "framer-motion";
import { Lock, Eye, EyeOff, AlertCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.get(`${API}/admin/verify`, {
        auth: { username, password }
      });
      
      if (response.data.status === "authenticated") {
        // Store credentials for future requests
        const encoded = btoa(`${username}:${password}`);
        sessionStorage.setItem("adminAuth", encoded);
        sessionStorage.setItem("admin_auth", encoded);
        onLogin({ username, password });
      }
    } catch (err) {
      setError("Usuario o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      data-testid="admin-login"
      className="min-h-screen bg-[#02040a] flex items-center justify-center p-4"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass-card p-8 w-full max-w-md"
      >
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#3b82f6]/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-[#3b82f6]" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Panel Administrativo</h1>
          <p className="text-[#94a3b8]">Global Metafora APP</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 mb-6">
              <AlertCircle className="w-5 h-5" />
              <span>{error}</span>
            </div>
          )}

          <div className="mb-4">
            <label className="block text-[#94a3b8] text-sm mb-2">Usuario</label>
            <input
              type="text"
              data-testid="admin-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="contact-input w-full"
              placeholder="admin"
            />
          </div>

          <div className="mb-6">
            <label className="block text-[#94a3b8] text-sm mb-2">Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                data-testid="admin-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="contact-input w-full pr-12"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#94a3b8] hover:text-white"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            data-testid="admin-submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            <span>{loading ? "Verificando..." : "Ingresar"}</span>
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
